<template>
  <div class="home-container">
    <div class="home-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户协议" name="agreement">
          <ueditor v-model="addData.agreement" ></ueditor>
        </el-tab-pane>
        <el-tab-pane label="隐私政策" name="privacy">
          <ueditor v-model="addData.privacy"></ueditor>
        </el-tab-pane>
        <el-tab-pane label="联系物业" name="contact">
          <div style="font-size: 18px;font-weight: bold;">前台电话</div>
          <el-form>
            <el-form-item v-for="(item,i) in addData.contact.wArr" :key="i">
              <el-input style="width: 200px;margin-right: 10px;" v-model="item.name"></el-input>
              <el-input style="width: 300px;margin-right: 10px;" v-model="item.phone"></el-input>
              <i class="el-icon-delete" @click="del(i,1)"></i>
            </el-form-item>
          </el-form>
          <el-button type="primary" size="small" @click="add(1)">增加</el-button>
          <div style="font-size: 18px;font-weight: bold;margin-top: 20px;">监控室电话</div>
          <el-form>
            <el-form-item v-for="(item,i) in addData.contact.jArr" :key="i">
              <el-input style="width: 200px;margin-right: 10px;" v-model="item.name"></el-input>
              <el-input style="width: 300px;margin-right: 10px;" v-model="item.phone"></el-input>
              <i class="el-icon-delete" @click="del(i,2)"></i>
            </el-form-item>
          </el-form>
          <el-button type="primary" size="small" @click="add(2)">增加</el-button>
          <div style="font-size: 18px;font-weight: bold;margin-top: 20px;">场地预约管理员</div>
          <el-form> 
            <el-form-item label="联系方式">
              <el-input style="width: 200px;margin-right: 10px;" v-model="addData.contact.mPhone"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="积分明细" name="points">
          <div>
            <el-form :model="searchForm" ref="searchForm" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="用户账号/姓名" label-width="120px" prop="name" style="width: 80%">
                    <el-input
                      v-model="searchForm.name"
                      placeholder="请输入用户账号/姓名进行检索"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="变动项筛选" label-width="90px" prop="sourceType" style="width: 80%">
                    <el-select clearable filterable v-model="searchForm.sourceType">
                      <el-option :value="1" label="系统"></el-option>
                      <el-option :value="2" label="活动"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-button
                    size="small"
                    @click="onLoad"
                    type="primary"
                    icon="el-icon-search"
                    style="width: 90px"
                    >搜索</el-button
                  >
                  <el-button
                    size="small"
                    @click="restSearch"
                    type="danger"
                    style="width: 90px"
                    >重置</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-table
            border
            :data="
              tableData
            "
            v-loading="isShowloading"
            style="width: 100%"
          >
            <el-table-column prop="sourceType" label="变动项" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.sourceType == 1">{{scope.row.objectName || '系统'}}</div>
                <div v-if="scope.row.sourceType == 2">“{{scope.row.objectName}}”活动奖励</div>
                <div v-if="scope.row.sourceType == 3">礼品兑换“{{scope.row.objectName}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="integrals" label="变动明细" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.type == 1?'+':'-' }} {{ scope.row.integrals }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="变动时间" align="center">
            </el-table-column>
            <el-table-column prop="phone" label="用户账号" align="center">
            </el-table-column>
            <el-table-column prop="userName" label="用户姓名" align="center">
            </el-table-column>
          </el-table>
          <div class="block" style="margin-top: 15px">
            <el-pagination
              align="center"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" v-if="activeName != 'points'">
        <el-button type="primary" @click="submit" :loading="btnLoading"
          >保 存</el-button
        >
      </span>
    </div>
  </div>
</template>

<script>
import ueditor from "../../components/ueditor";
export default {
  name: "",
  data() {
    return {
      activeName:"agreement",
      addData:{
        contact:{
          wArr:[],
          jArr:[],
          mPhone:''
        }
      },
      btnLoading:false,
      searchForm: {},
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      isShowloading: false,
    };
  },
  components:{
    ueditor
  },
  mounted() {
    this.getDict()
  },
  methods: {
    getDict(){
      this.$Apis.dictGetInfo({
        code:this.activeName
      }).then(res=>{
        if(res.code == 200){
          this.addData.id = res.data.id
          if(this.activeName == "agreement"){
            this.addData.agreement = JSON.parse(res.data.content)
          }else if(this.activeName == "privacy"){
            this.addData.privacy = JSON.parse(res.data.content)
          }
          else if(this.activeName == "contact"){
            
            this.addData.contact = (JSON.parse(res.data.content))
          }
        }
      })
    },
    add(type){
      if(type == 1){
        this.addData.contact.wArr.push({
          name:'',
          phone:''
        })
      }
      if(type == 2){
        this.addData.contact.jArr.push({
          name:'',
          phone:''
        })
      }
    },
    del(i,type){
      if(type == 1){
        this.addData.contact.wArr.splice(i,1)
      }
      if(type == 2){
        this.addData.contact.jArr.splice(i,1)
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(){
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        // type: 1,
        ...this.searchForm
      };
      this.$Apis.userIntegralsRecordGetList(page).then(res=>{
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      })
    },
    handleClick(tab, event) {
      if(this.activeName == "points"){
        this.onLoad()
      }else{
        this.getDict()
      }
      
    },
    submit(){
      this.btnLoading = true
      let data = {
        code: this.activeName,
        content:'',
        id: this.addData.id
      }
      if(this.activeName == "agreement"){
        data.content = JSON.stringify(this.addData.agreement)
      }else if(this.activeName == "privacy"){
        data.content = JSON.stringify(this.addData.privacy)
      }else if(this.activeName == "contact"){
        data.content = JSON.stringify(this.addData.contact)
      }
      this.$Apis.dictSetInfo(data).then((res) => { 
        this.btnLoading = false;
        if(res.code == 200){
          this.$message.success("保存成功");
        }
      });
    }
  },
};
</script>
<style scoped>
.dialog-footer{
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
/deep/ .w-e-text-container{
  height: 60vh !important;
}
/deep/ .w-e-text{
  min-height: auto !important;
}
</style>